export const USER='USER';
export const ROLES='ROLES';
export const MODULES='MODULES';
export const MENU_TOGGLE='MENU_TOGGLE';
export const INIT_GRID='INIT_GRID';
export const ISAUTHENTICATED = "ISAUTHENTICATED";
export const SIDEBARMENUS = "SIDEBARMENUS";
export const DASHBOARDPUBS = "DASHBOARDPUBS";
export const DASHBOARDTAGS = "DASHBOARDTAGS";
export const DASHBOARDARTICLES = "DASHBOARDARTICLES";
